import { render, staticRenderFns } from "./KnowledgeGraph.vue?vue&type=template&id=44247e44&scoped=true"
import script from "./KnowledgeGraph.vue?vue&type=script&lang=js"
export * from "./KnowledgeGraph.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeGraph.vue?vue&type=style&index=0&id=44247e44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44247e44",
  null
  
)

export default component.exports